import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TealiumParams, trackEvent } from '@is24at/react-tracking';
import { byIsSafari } from 'core/runtimeConfigReducer';
import Form from '../Form';
import { FormTracking } from './tracking';

const mapStateToProps = (state: any) => ({
  mandatoryFields: state.contactRequestForm.mandatoryFields,
  companyName: state.expose.view.companyName,
  cwid: state.expose.view.cwid,
  formSubmitted: state.contactRequestForm.formSubmitted,
  formSubmitStatus: state.contactRequestForm.formSubmitStatus,
  isSafari: byIsSafari(state),
});

const mapDispatchToProps = (dispatch: any) => {
  const Actions = bindActionCreators({ trackEvent }, dispatch);
  return {
    trackingFn: () =>
      Actions.trackEvent({
        [TealiumParams.CATEGORY]: FormTracking.CATEGORY,
        [TealiumParams.ACTION]: FormTracking.ACTION,
        [TealiumParams.LABEL]: FormTracking.LABEL,
        [TealiumParams.GA4_EVENT_NAME]: 'contact_mail',
        [TealiumParams.GA4_EVENT_PRODUCT]: 'contactrequest',
        [TealiumParams.GA4_EVENT_PARAMETER_1]: 'realtor_profile_form',
      }),
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
